import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// 批量新增
export function batchappend(data) {
  return axios.request({
    // urlObj.wss
    url: urlObj.wss + 'wss-part/partsBatch/savePartsBatch',
    // url: 'http://192.168.0.123:5000/wss-part/partsBatch/savePartsBatch',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}
// 批量修改
export function batchamend(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/batchUpdate',
    // url: 'http://192.168.0.114:5000/wss-part/parts/batchUpdate',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}
// 关联链
export function relation(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listRelationByPartId',
    // url: 'http://192.168.0.122:5000/wss-part/parts/listRelationByPartId',
    method: 'get',
    params
  })
}

// 替换连
export function replace(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listReplaceByPartId',
    // url: 'http://192.168.0.122:5000/wss-part/parts/listReplaceByPartId',
    method: 'get',
    params
  })
}
// 导出
export function derivegoods(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/export',
    // url: 'http://192.168.0.122:5000/wss-part/parts/export',
    method: 'get',
    params
  })
}
